import { Col, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import TableComponent from 'components/atoms/TableComponent';
import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import identifikaceEmitenta from 'services/akcionar/emise/identifikaceEmitenta';
import podaneZadostiApi, { IPodaneZadosti, IZadostiTable } from 'services/akcionar/emise/podaneZadosti';

const ListinneCp: React.FC = () => {
    const { aktivniFirma } = useContext(Context);
    const [podaneZadosti, setPodaneZadosti] = useState<IZadostiTable>();
    const [errStatus, setErrStatus] = useState<number>();
    const [loading, setLoading] = useState<boolean>(false);
    const [offset, setOffset] = useState<number>(0);
    // const [refetchData, setRefetchData] = useState<boolean>(false);

    /** Clean up akce */
    useEffect(() => {
        return () => setLoading(false);
    }, []);

    useEffect(() => {
        setLoading(true);
        setErrStatus(0);
        podaneZadostiApi('datumzmeny:desc', aktivniFirma?.ic ? aktivniFirma.ic : '', 'zadostoisin', 10, offset)
            .then(resp => {
                setPodaneZadosti(resp);
            })
            .catch((err: any) => {
                setErrStatus(err.response?.status);
            })
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [offset]);

    const columns = [
        {
            title: <TranslateText>TYP_ZADOSTI</TranslateText>,
            key: 'typzadosti',
            dataIndex: 'typzadosti',
            render: (typzadosti: string, row: IPodaneZadosti) =>
                typzadosti ? (
                    <div>
                        <TranslateText>{`EMISE_PODZAD_${typzadosti.toUpperCase().split(' ').join('_')}`}</TranslateText>
                        {row.druhcp && (
                            <>
                                {' ('}
                                <TranslateText>
                                    {`ISIN_EMISE_DRUH_${row.druhcp.toUpperCase().split(' ').join('_')}`}
                                </TranslateText>
                                {')'}
                            </>
                        )}
                    </div>
                ) : (
                    ''
                )
        },
        {
            title: <TranslateText>EMP_PODANE_ZADOSTI_STAV</TranslateText>,
            key: 'stav',
            dataIndex: 'stav',
            render: (stav: string) =>
                stav ? (
                    <TranslateText>{`EMP_PODANE_ZADOSTI_${stav.toUpperCase().split(' ').join('_')}`}</TranslateText>
                ) : (
                    ''
                )
            // sorter: (a: { stav: string }, b: { stav: string }) => (a.stav && b.stav ? a.stav.localeCompare(b.stav) : 0)
        },
        {
            dataIndex: 'edit',
            key: 'edit',
            width: 200,
            render: (_: IPodaneZadosti, row: IPodaneZadosti, index: number) => (
                <AnchorComponent
                    id={`ListinneCpEditBtn${index}`}
                    onClick={() => {
                        setLoading(true);
                        identifikaceEmitenta('get', row.id).then(data => {
                            console.log(data);
                        });
                    }}
                >
                    <TranslateText>ZOBRAZIT</TranslateText>
                </AnchorComponent>
            )
        }
    ];

    return (
        <>
            {errStatus ? (
                <Row
                    justify="center"
                    align="middle"
                    style={{
                        height: '100%'
                    }}
                >
                    <Col span={16} flex={'0 0 auto'}>
                        {errStatus === 404 ? (
                            <Title text="RESPONSE_ERROR_404" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Col>
                </Row>
            ) : (
                <>
                    <Title level={3} text="ZADOSTI_ISIN" />
                    <Row gutter={8}>
                        <Col span={24}>
                            <TableComponent
                                columns={columns}
                                rowKey={record => record.id}
                                dataSource={podaneZadosti?.zadosti}
                                loading={!podaneZadosti || loading}
                                pagination={{
                                    total: podaneZadosti?.count,
                                    onChange: page => setOffset((page - 1) * 10),
                                    current: offset / 10 + 1,
                                    showSizeChanger: false
                                }}
                                locale={{
                                    emptyText: <TranslateText>ZADNE_UDAJE</TranslateText>
                                }}
                            />
                        </Col>
                    </Row>
                </>
            )}
        </>
    );
};

export default ListinneCp;
